import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat2-icon',
  templateUrl: './communication-chat2.component.html'
})
export class CommunicationChat2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
